(() => {
  if (window.H7OverlayCoordinator) return;

  const queue = [];
  let active = null;

  const pump = () => {
    if (active || queue.length === 0) return;
    queue.sort((a, b) => b.priority - a.priority || a.createdAt - b.createdAt);
    active = queue.shift();
    active.resolve();
  };

  window.H7OverlayCoordinator = {
    request(id, options = {}) {
      if (!id) return Promise.resolve();
      if (active?.id === id) return Promise.resolve();

      const existing = queue.find((item) => item.id === id);
      if (existing) return existing.promise;

      const item = {
        id,
        priority: Number(options.priority || 0),
        createdAt: Date.now(),
      };
      item.promise = new Promise((resolve) => {
        item.resolve = resolve;
      });
      queue.push(item);
      pump();
      return item.promise;
    },

    release(id) {
      for (let index = queue.length - 1; index >= 0; index -= 1) {
        if (queue[index].id === id) queue.splice(index, 1);
      }
      if (active?.id === id) active = null;
      pump();
    },
  };
})();
